import React from 'react'
import ChipInput from 'material-ui-chip-input'
import { withStyles, createStyles } from '@material-ui/core/styles'

const styles = createStyles({
    label: {
        color : '#3CA7AC',
        fontSize : 18,
        fontWeight: 600,
        textTransform: 'capitalize',
    },
    chipContainer: {
        border: '1px solid #C7C7C7',
        paddingTop: 6,
        paddingLeft: 5,
    },
    underline : {
        '&:before' : {
            backgroundColor : 'initial'
        }
    }
})


class EnumInput extends React.Component {

    state = {
        values : []
    }

    handleAddChip = value => {
        const values = [...this.state.values, value]
        this.setState({ values })
        if(this.props.input)
            this.props.input.onChange(values)
    }

    handleDeleteChip = deletedValue => {
        const values = this.state.values.filter((v) => v !== deletedValue)
        this.setState({ values })
        if(this.props.input)
            this.props.input.onChange(values)
    }

    componentDidMount(){
        if(this.props.input)
            this.setState({ values : this.props.input.value || [] })
    }

    render(){
        const { ...rest } = this.props

        return (
            <ChipInput 
                value={this.state.values}
                onAdd={(chip) => this.handleAddChip(chip)}
                onDelete={(chip) => this.handleDeleteChip(chip)}
                InputLabelProps={{
                    shrink: true,
                    className : this.props.classes.label
                }} 
                {...rest} 
            />
        )
    }

}

export default withStyles(styles)(EnumInput)